import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const items = [{
  title: '30 Fichas Diarias',
  desc: '(Afirmación + Actividad + Registro de emociones).'
}, {
  title: 'Guía para Padres',
  desc: 'Cómo leer las afirmaciones para que realmente conecten.'
}, {
  title: 'Separadores de Progreso',
  desc: 'Para que vean cómo avanza su viaje espacial.'
}, {
  title: 'Certificado "Misión Cumplida"',
  desc: 'Un diploma especial para colgar en su habitación al terminar los 30 días.'
}];
export function PackageContents() {
  return <section className="relative z-10 px-6 py-16 md:py-24" data-id="element-66">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto glass-card p-8 md:p-12 relative overflow-hidden" data-id="element-67">
        {/* Decorative background glow */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl -mr-32 -mt-32 pointer-events-none" data-id="element-68"></div>

        <div className="text-center mb-10 relative z-10" data-id="element-69">
          <h2 className="text-3xl md:text-4xl font-bold text-gold font-heading mb-4" data-id="element-70">
            ¿Qué recibirás hoy?
          </h2>
          <p className="text-lg text-warmWhite font-body" data-id="element-71">
            PDF de 40 páginas (Tamaño Carta) listo para imprimir:
          </p>
        </div>

        <ul className="space-y-6 relative z-10" data-id="element-72">
          {items.map((item, index) => <motion.li key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1 + 0.3,
          duration: 0.5
        }} className="flex items-start" data-id="element-73">
              <Star className="w-6 h-6 text-gold fill-gold mr-4 mt-1 flex-shrink-0" data-id="element-74" />
              <div data-id="element-75">
                <h3 className="text-xl font-bold text-white font-heading" data-id="element-76">
                  {item.title}
                </h3>
                <p className="text-mutedPurple font-body mt-1" data-id="element-77">{item.desc}</p>
              </div>
            </motion.li>)}
        </ul>
      </motion.div>
    </section>;
}